import { Box, Button, Card, Container, Divider, TextField, Typography, useTheme } from "@mui/material";
import Logo from "components/Logo";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AccountContext } from "services/account";
import { ERROR_MESSAGE, getUserData, login } from "services/api";
import { isAllFalseValue } from "services/helper";
const SignIn = () => {
	const theme = useTheme();
	const { t } = useTranslation(["common", "validation"]);
	const [searchParams] = useSearchParams();

	const navigate = useNavigate();
	const account = React.useContext(AccountContext);

	const [formData, setFormData] = React.useState({ email: "", password: "" });
	const [errorTexts, setErrorTexts] = React.useState({ email: "", password: "" });

	const [isLoginLoading, setIsLoginLoading] = React.useState(false);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};

	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			setIsLoginLoading(true);
		}
	};

	const handleLogin = () => {
		let newErrorTexts = { email: "", password: "" };
		Object.keys(errorTexts).forEach((name: string | number | symbol) => {
			if (formData[name] === "") {
				newErrorTexts[name] = "Required";
			}
		});
		setErrorTexts(newErrorTexts);
		if (isAllFalseValue(newErrorTexts)) {
			login(formData.email, formData.password).then(async (resp) => {
				console.log(resp);
				if (resp.message) {
					switch (resp.message) {
						case ERROR_MESSAGE.EMAIL_NOT_FOUND:
							newErrorTexts.email = "Email not found";
							break;
						case ERROR_MESSAGE.INVALID_PASSWORD:
							newErrorTexts.password = "Invalid password";
							break;
						case ERROR_MESSAGE.INVALID_EMAIL_OR_PASSWORD:
							newErrorTexts.email = "Invalid email or password";
							newErrorTexts.password = "Invalid email or password";
							break;
						default:
							console.log(resp.message);
							break;
					}
					setErrorTexts(newErrorTexts);
					setIsLoginLoading(false);
				} else {
					await account.setAccount({ ...resp, tokenUpdateTime: Date.now() });
					window.location.href = "/app/";
				}
			});
		} else {
			setIsLoginLoading(false);
		}
	};
	React.useEffect(() => {
		if (isLoginLoading) handleLogin();
	}, [isLoginLoading]);

	React.useEffect(() => {
		const token = searchParams.get("secretKey");
		if (token) {
			account.clearAccount();
			getUserData(token).then(async (resp) => {
				if (!resp || resp?.error) return;
				await account.setAccount({ ...resp, tokenUpdateTime: Date.now(), secretKey: token });
				window.location.href = "/app/";
			});
		} else if (account.getToken()) {
			window.location.href = "/app/";
		}
	}, []);

	return (
		<Box
			minHeight="100vh"
			display="flex"
			justifyContent="center"
			alignItems="center"
			flexDirection="column">
			<Box
				m={2}
				mt="auto"></Box>
			<Container maxWidth="xs">
				<Card>
					<Box
						display="flex"
						justifyContent="center"
						alignItems="center"
						flexDirection="column"
						p={4}>
						<Box
							mb={2}
							display="flex"
							alignItems="center">
							<Logo />
							<Typography variant="h6">{t("signIn")}</Typography>
						</Box>
						<form>
							<TextField
								margin="normal"
								fullWidth
								name="email"
								label={t("email")}
								error={!!errorTexts.email}
								helperText={t(errorTexts.email, { ns: "validation" })}
								value={formData.email}
								onChange={handleChange}
								onKeyDown={handleKeyDown}
								slotProps={{ htmlInput: { autoComplete: "username" } }}
							/>
							<TextField
								margin="normal"
								fullWidth
								name="password"
								type="password"
								label={t("password")}
								error={!!errorTexts.password}
								helperText={t(errorTexts.password, { ns: "validation" })}
								value={formData.password}
								onChange={handleChange}
								onKeyDown={handleKeyDown}
								slotProps={{ htmlInput: { autoComplete: "current-password" } }}
							/>
							<Box
								width="100%"
								mt={2}
								mb={2}>
								<Button
									disabled={isLoginLoading}
									fullWidth
									onClick={() => setIsLoginLoading(true)}
									variant="contained"
									color="primary">
									{t("signIn")}
								</Button>
							</Box>
						</form>

						<Box
							width="100%"
							mt={2}>
							<Divider />
						</Box>
						<Box my={2}>
							<Box
								component={"a"}
								href="/app/signup">
								{t("register")}
							</Box>
						</Box>
						<Box>
							<Box
								component={"a"}
								href="/app/forget-password">
								{t("forgetPassword")}
							</Box>
						</Box>
					</Box>
				</Card>
			</Container>
			{/* <Box my={2}>
				<LanguagePopper />
			</Box> */}
			<Box mt="auto">
				<Container maxWidth="xs">
					<Divider />
					<Box my={2}>
						<Typography
							color="text.primary"
							variant="body2">
							Copyright © {new Date().getFullYear()} MiExpert Limited.
						</Typography>
					</Box>
				</Container>
			</Box>
		</Box>
	);
};

export default SignIn;
